import { ISPFieldTypeWithControl, ISPFieldConfig } from '../model';

/**
 * Type guard for field, to check that it's have originalControl
 *
 * @param config - field config
 */
export function isConfigWithControl(
  config: ISPFieldConfig,
): config is ISPFieldConfig<ISPFieldTypeWithControl> {
  return 'originalControl' in config.props;
}
